/* Mayekoo fundraiser v4 — presentation-shell interactions only.
   Does not modify checkout, Fundraiser Widget behavior, donor-wall logic,
   Updates data, EasyPie, Stripe, orders, or backend state. */
(function () {
  'use strict';

  function readI18n() {
    if (window.__mayekooFundraiserI18n) return window.__mayekooFundraiserI18n;
    var script = document.getElementById('mayekoo-fundraiser-i18n');
    var payload = {};
    if (script) {
      try { payload = JSON.parse(script.textContent || '{}'); } catch (err) { payload = {}; }
    }
    window.__mayekooFundraiserI18n = payload;
    return payload;
  }

  function qsAll(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTabs(root) {
    qsAll(root, '[data-mkf-tabs]').forEach(function (wrap) {
      if (wrap.dataset.mkfBound === '1') return;
      wrap.dataset.mkfBound = '1';

      var btns = qsAll(wrap, '[data-mkf-tab]');
      var panes = qsAll(wrap, '[data-mkf-pane]');
      if (!btns.length || !panes.length) return;

      function activate(button, focus) {
        var target = button.dataset.mkfTab;
        btns.forEach(function (b) {
          var selected = b === button;
          b.setAttribute('aria-selected', selected ? 'true' : 'false');
          b.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panes.forEach(function (pane) {
          pane.hidden = pane.dataset.mkfPane !== target;
        });
        if (focus) button.focus();

        if (target === 'updates') {
          qsAll(wrap, '[data-mayekoo-updates-v2="feed"]').forEach(function (feed) {
            feed.classList.remove('is-tab-hidden');
            feed.hidden = false;
            feed.removeAttribute('hidden');
            if (feed.style) feed.style.removeProperty('display');
          });
        }

        /* Updates/feed blocks can initialize while hidden. A resize event after
           reveal lets responsive app code recalculate without coupling to it. */
        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
      }

      btns.forEach(function (button, index) {
        button.addEventListener('click', function () { activate(button, false); });
        button.addEventListener('keydown', function (event) {
          var nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % btns.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + btns.length) % btns.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = btns.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activate(btns[nextIndex], true);
        });
      });

      var initiallySelected = btns.find(function (b) { return b.getAttribute('aria-selected') === 'true'; }) || btns[0];
      activate(initiallySelected, false);
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        var ok = document.execCommand('copy');
        document.body.removeChild(area);
        ok ? resolve() : reject(new Error('copy failed'));
      } catch (err) {
        document.body.removeChild(area);
        reject(err);
      }
    });
  }

  function initShare(root) {
    qsAll(root, '[data-mkf-share]').forEach(function (btn) {
      if (btn.dataset.mkfBound === '1') return;
      btn.dataset.mkfBound = '1';

      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      var url = btn.dataset.mkfUrl || window.location.href;
      var title = btn.dataset.mkfTitle || document.title;

      function closePopover() {
        if (!pop) return;
        pop.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (event) {
        var mobile = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
        if (mobile && navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        if (!pop) return;
        event.stopPropagation();
        var willOpen = pop.hidden;
        pop.hidden = !willOpen;
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) {
          var firstLink = pop.querySelector('a');
          if (firstLink) firstLink.focus();
        }
      });

      if (!pop) return;

      document.addEventListener('click', function (event) {
        if (!pop.hidden && !pop.contains(event.target) && event.target !== btn) closePopover();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !pop.hidden) {
          closePopover();
          btn.focus();
        }
      });

      var copyLink = pop.querySelector('[data-mkf-copy]');
      if (copyLink) {
        copyLink.addEventListener('click', function (event) {
          event.preventDefault();
          var original = copyLink.textContent;
          copyText(url).then(function () {
            copyLink.textContent = readI18n().link_copied || 'Link copied \u2713';
            window.setTimeout(function () { copyLink.textContent = original; }, 1500);
          }).catch(function () {
            copyLink.textContent = readI18n().copy_failed || 'Copy failed';
            window.setTimeout(function () { copyLink.textContent = original; }, 1500);
          });
        });
      }
    });
  }

  function initGallery(root) {
    qsAll(root, '[data-mkf-gallery]').forEach(function (gallery) {
      if (gallery.dataset.mkfBound === '1') return;
      gallery.dataset.mkfBound = '1';

      var sources = [];
      try { sources = JSON.parse(gallery.dataset.mkfImages || '[]'); } catch (err) { sources = []; }

      var lightbox = gallery.querySelector('[data-mkf-lightbox]');
      if (lightbox && sources.length) {
        var image = lightbox.querySelector('[data-mkf-lb-img]');
        var thumbs = lightbox.querySelector('[data-mkf-lb-thumbs]');
        var closeButton = lightbox.querySelector('[data-mkf-lb-close]');
        var previousButton = lightbox.querySelector('[data-mkf-lb-prev]');
        var nextButton = lightbox.querySelector('[data-mkf-lb-next]');
        var index = 0;
        var returnFocus = null;

        sources.forEach(function (source, i) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'mkf-lb-thumb';
          button.setAttribute('aria-label', 'Photo ' + (i + 1));
          var thumb = document.createElement('img');
          thumb.src = source;
          thumb.alt = '';
          button.appendChild(thumb);
          button.addEventListener('click', function () { index = i; draw(); });
          thumbs.appendChild(button);
        });

        function draw() {
          image.src = sources[index];
          image.setAttribute('aria-label', 'Photo ' + (index + 1) + ' of ' + sources.length);
          qsAll(thumbs, 'button').forEach(function (button, i) {
            button.classList.toggle('on', i === index);
            button.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }

        function open(i, opener) {
          index = i;
          returnFocus = opener || document.activeElement;
          draw();
          lightbox.hidden = false;
          closeButton.focus();
        }

        function close() {
          lightbox.hidden = true;
          if (returnFocus && returnFocus.focus) returnFocus.focus();
        }

        qsAll(gallery, '[data-mkf-open]').forEach(function (photoButton) {
          photoButton.addEventListener('click', function () {
            var requested = parseInt(photoButton.dataset.mkfOpen, 10) || 0;
            open(Math.min(requested, sources.length - 1), photoButton);
          });
        });

        closeButton.addEventListener('click', close);
        previousButton.addEventListener('click', function () { index = (index - 1 + sources.length) % sources.length; draw(); });
        nextButton.addEventListener('click', function () { index = (index + 1) % sources.length; draw(); });
        lightbox.addEventListener('click', function (event) { if (event.target === lightbox) close(); });

        lightbox.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') { event.preventDefault(); close(); return; }
          if (event.key === 'ArrowLeft') { event.preventDefault(); index = (index - 1 + sources.length) % sources.length; draw(); return; }
          if (event.key === 'ArrowRight') { event.preventDefault(); index = (index + 1) % sources.length; draw(); return; }
          if (event.key !== 'Tab') return;

          var focusables = qsAll(lightbox, 'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
            .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });

        draw();
      }

      var strip = gallery.querySelector('[data-mkf-strip]');
      var dots = qsAll(gallery, '[data-mkf-dot]');
      if (strip && dots.length) {
        var updateDots = function () {
          var slides = qsAll(strip, '.mkf-slide');
          if (!slides.length) return;
          var center = strip.scrollLeft + strip.clientWidth / 2;
          var bestIndex = 0;
          var bestDistance = Infinity;
          slides.forEach(function (slide, i) {
            var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            var distance = Math.abs(slideCenter - center);
            if (distance < bestDistance) { bestDistance = distance; bestIndex = i; }
          });
          dots.forEach(function (dot, i) { dot.classList.toggle('on', i === bestIndex); });
        };
        strip.addEventListener('scroll', updateDots, { passive: true });
        window.addEventListener('resize', updateDots, { passive: true });
        updateDots();
      }
    });
  }

  function initVideo(root) {
    qsAll(root, '[data-mkf-video]').forEach(function (video) {
      if (video.dataset.mkfBound === '1') return;
      video.dataset.mkfBound = '1';
      var facade = video.querySelector('[data-mkf-vfacade]');
      if (!facade || !video.dataset.mkfEmbed) return;

      facade.addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.src = video.dataset.mkfEmbed;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = readI18n().play_video || 'Play fundraiser video';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        video.appendChild(iframe);
        facade.remove();
      });
    });
  }

  function initGiveBar(root) {
    qsAll(root, '[data-mkf-givebar] a[href^="#"]').forEach(function (link) {
      if (link.dataset.mkfBound === '1') return;
      link.dataset.mkfBound = '1';
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initWidgetDonorReflow(root) {
    qsAll(root, '[data-mayekoo-fundraiser]').forEach(function (widget) {
      if (widget.dataset.mkfDonorReflowBound === '1') return;
      widget.dataset.mkfDonorReflowBound = '1';
      widget.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-mayekoo-tab], [data-tab]');
        if (!tab || !widget.contains(tab)) return;
        var name = tab.getAttribute('data-mayekoo-tab') || tab.getAttribute('data-tab');
        if (name !== 'donors') return;
        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
      });
    });
  }

  function localizeUpdatesV2(root) {
    var i18n = readI18n();
    var label = i18n.updates_count_label || 'Updates';
    var unavailable = i18n.updates_unavailable || 'Updates are unavailable right now.';

    function apply() {
      qsAll(root, '.mayekoo-updates-v2__count').forEach(function (el) {
        var countNode = el.querySelector('[data-updates-count]');
        var count = countNode ? countNode.textContent : '0';
        var current = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var expected = label + ' (' + count + ')';
        if (current === expected) return;
        el.textContent = '';
        el.appendChild(document.createTextNode(label + ' ('));
        var span = document.createElement('span');
        span.setAttribute('data-updates-count', '');
        span.textContent = count;
        el.appendChild(span);
        el.appendChild(document.createTextNode(')'));
      });
      qsAll(root, '[data-mayekoo-updates-v2="feed"] [data-empty]').forEach(function (el) {
        var text = (el.textContent || '').trim();
        if (text === 'Updates are unavailable right now.') el.textContent = unavailable;
      });
    }

    apply();
    qsAll(root, '[data-mayekoo-updates-v2="feed"]').forEach(function (feed) {
      if (feed.dataset.mkfUpdatesI18n === '1') return;
      feed.dataset.mkfUpdatesI18n = '1';
      new MutationObserver(apply).observe(feed, { childList: true, subtree: true, characterData: true });
    });
  }

  function init(root) {
    root = root || document;
    initTabs(root);
    initShare(root);
    initGallery(root);
    initVideo(root);
    initGiveBar(root);
    initWidgetDonorReflow(root);
    localizeUpdatesV2(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
